<template>
  <div class="succ-container">
    <div v-if="postContent.success" class="succ-item succ-icon"></div>
    <div v-else class="succ-item fail-icon"></div>
    <div class="succ-item succ-text">{{ postContent.text }}</div>
    <div class="succ-item succ-notify">
      <span class="succ-sp" v-for="val in postContent.notify" v-bind:key="val">
        {{ val }}
      </span>
    </div>
    <div v-if="postContent.btnShow" class="succ-item succ-btn">
      <el-button type="primary" @click.native="SuccSubmit">{{
        postContent.btnText
      }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    post: {
      type: Object
    }
  },
  name: 'Successed',
  data() {
    return {
      postContent: {
        text: '提交申请成功',
        notify: [],
        btnText: '完成',
        btnShow: true,
        success: true
      }
    }
  },
  computed: {},
  created() {
    Object.assign(this.postContent, this.post)
  },
  methods: {
    SuccSubmit() {
      this.$emit('SuccSubmit')
    }
  }
}
</script>

<style scoped>
.succ-container .succ-btn .el-button--primary {
  font-size: 16px;
  width: 140px;
}
</style>

<style lang="scss" scoped>
.succ-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  // width: 300px;
  .succ-item {
    margin: 15px auto;
  }
  .succ-icon {
    background: url('./images/success.png') no-repeat;
    width: 90px;
    height: 90px;
  }
  .fail-icon {
    background: url('./images/fail.png') no-repeat;
    width: 90px;
    height: 90px;
  }
  .succ-notify {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    .succ-sp {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #858585;
      text-align: center;
    }
  }
  .succ-text {
    font-family: MicrosoftYaHei;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0px;
    color: #262626;
  }
}
</style>
